import { MoveList } from '@/modules/move/views/moveList/moveList';
import React from 'react';

const List: React.FC = () => {
  return <MoveList
    fields={[
      {
        key: 'search',
        width: 25,
      },
      {
        key: 'type',
        width: 25,
      },
      {
        key: 'beneficiaryStatus',
        width: 25,
      },
      {
        key: 'createdAtMin',
        width: 25,
      },
    ]}
    columns={['name', 'createdBy', 'type', 'provider', 'status', 'uploadedAt']}
  />;
};

export default List;
